// extracted by mini-css-extract-plugin
module.exports = {"ListOfForumsRight":"pw_a","ListOfForumsRight__brandDaysPosts":"pw_b bhc_rq"};